export default __webpack_public_path__ + "static/media/9_1_3.bec751da.png";